import { useState } from 'react';
import { useNavigate } from 'react-router';
import { Button } from '@/components/ui/button';
import { requestGoogleCredential, type GoogleAuthConfig } from '@/lib/google-auth';
import { api, errMsg, setSession, type SessionResponse } from '@/lib/api';

export function GoogleSignIn({
  config,
  next,
  invitationToken,
}: {
  config: GoogleAuthConfig;
  next: string;
  invitationToken?: string;
}) {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function signIn() {
    setBusy(true);
    setError(null);
    try {
      const tokens = await requestGoogleCredential(config);
      const session = await api<SessionResponse>('/auth/google', {
        method: 'POST',
        json: { ...tokens, invitationToken },
        auth: false,
      });
      setSession(session);
      navigate(next, { replace: true });
    } catch (err) {
      setError(errMsg(err, 'Sign-in failed'));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="space-y-3">
      <Button className="w-full cursor-pointer" onClick={signIn} disabled={busy}>
        {busy ? 'Signing in…' : 'Continue with Google'}
      </Button>
      {error && (
        <p
          role="alert"
          className="rounded-md border border-red-200 bg-red-50 p-3 text-sm text-red-800"
        >
          {error}
        </p>
      )}
    </div>
  );
}
